import {createRefetchContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {mapCompressedAggregatedResourceNumbers} from '../UtilizationReportUtils';

const MonthByMonthPersonLoaderOld = ({relay, viewer, children, ...props}) => {
	const formatData = () => {
		return viewer.company.allPersonsGlobalSearch.edges
			.map(edge => edge.node)
			.map(person => {
				const {id, firstName, lastName, profilePictureId} = person;
				const aggregatedResourceNumbers = mapCompressedAggregatedResourceNumbers(person.aggregatedResourceNumbers, ['forecastBillableUtilization', 'forecastResourceUtilization']);
				const aggregatedResourceNumbersByMonth = aggregatedResourceNumbers.reduce((map, resourceNumbers) => {
					const date = resourceNumbers.startDate.clone();
					while (date.isBefore(resourceNumbers.endDate)) {
						map[date.month()] = resourceNumbers;
						date.add(1, 'month');
					}
					return map;
				}, {});
				return {
					person: {
						id,
						firstName,
						lastName,
						profilePictureId,
					},
					aggregatedResourceNumbersByMonth,
				};
			});
	};

	const rows = formatData();
	return children({data: {rows}, ...props});
};

export const monthByMonthPersonLoaderOldQuery = graphql`
	query MonthByMonthPersonLoaderOldQuery_Query($searchQuery: TaskSearchQueryType, $startYear: Int!, $startMonth: Int!, $startDay: Int!, $endYear: Int!, $endMonth: Int!, $endDay: Int!, $pageSize: Int) {
		viewer {
			actualPersonId
			component(name: "utilization_monthbymonth_person_loader")
			...MonthByMonthPersonLoaderOld_viewer @arguments(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, pageSize: $pageSize)
		}
	}
`;

export default injectIntl(
	withRouter(
		createRefetchContainer(
			MonthByMonthPersonLoaderOld,
			{
				viewer: graphql`
					fragment MonthByMonthPersonLoaderOld_viewer on Viewer
					@argumentDefinitions(
						searchQuery: {type: "TaskSearchQueryType"}
						startYear: {type: "Int!"}
						startMonth: {type: "Int!"}
						startDay: {type: "Int!"}
						endYear: {type: "Int!"}
						endMonth: {type: "Int!"}
						endDay: {type: "Int!"}
						pageSize: {type: "Int"}
					) {
						company {
							allPersonsGlobalSearch(first: $pageSize, searchQuery: $searchQuery) {
								edges {
									node {
										id
										firstName
										lastName
										profilePictureId
										aggregatedResourceNumbers(
											startYear: $startYear
											startMonth: $startMonth
											startDay: $startDay
											endYear: $endYear
											endMonth: $endMonth
											endDay: $endDay
											aggregateLevel: MONTH
											aggregates: ["forecastBillableUtilization", "forecastResourceUtilization"]
										)
									}
								}
							}
						}
					}
				`,
			},
			graphql`
				query MonthByMonthPersonLoaderOldRefetchQuery($pageSize: Int, $startYear: Int!, $startMonth: Int!, $startDay: Int!, $endYear: Int!, $endMonth: Int!, $endDay: Int!, $searchQuery: TaskSearchQueryType) {
					viewer {
						...MonthByMonthPersonLoaderOld_viewer @arguments(pageSize: $pageSize, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, searchQuery: $searchQuery)
					}
				}
			`
		)
	)
);
